<template>
  <div v-if="!$store.getters.getMobilePhoneActive" class="web_home_style" height="70vh" align-center justify-center>
    <v-flex  xs5 class="elevation-2 mx-auto containerBackground" style="height: 30vh; margin-top: 5em;">
      <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <h3 class="mb-4" v-if="!loading">{{this.leadText}}</h3>
        <v-card class="elevation-0 transparent" style="text-align: left">
          <h4>
            <v-icon v-if="statusCheck.Order">check_circle_outline</v-icon>
            <v-icon v-if="!statusCheck.Order">highlight_off</v-icon>
            {{$translate('PAR_CON_ORDER')}} {{queryObject.OrderId}}
          </h4>
          <h4>
            <v-icon v-if="statusCheck.Confirmation">check_circle_outline</v-icon>
            <v-icon v-if="!statusCheck.Confirmation">highlight_off</v-icon>
            {{$translate('PAR_CON_CONFIRMATION')}} {{queryObject.ConfirmationId}}
          </h4>
          <h4>
            <v-icon v-if="statusCheck.Status">check_circle_outline</v-icon>
            <v-icon v-if="!statusCheck.Status">highlight_off</v-icon>
            {{$translate('PAR_CON_STATUS')}} {{orderStatus}}
          </h4>
        </v-card>
      </v-layout>
    </v-flex>
  </div>
  <div v-else class="web_home_style_mobile" height="70vh" align-center justify-center>
    <v-flex xs10 class="elevation-2 mx-auto containerBackground" style="height: 30vh; margin-top: 15em;">
      <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <h3 class="mb-4" v-if="!loading">{{this.leadText}}</h3>
        <v-card class="elevation-0 transparent" style="text-align: left">
          <h4>
            <v-icon v-if="statusCheck.Order">check_circle_outline</v-icon>
            <v-icon v-if="!statusCheck.Order">highlight_off</v-icon>
            {{$translate('PAR_CON_ORDER')}} {{queryObject.OrderId}}
          </h4>
          <h4>
            <v-icon v-if="statusCheck.Confirmation">check_circle_outline</v-icon>
            <v-icon v-if="!statusCheck.Confirmation">highlight_off</v-icon>
            {{$translate('PAR_CON_CONFIRMATION')}} {{queryObject.ConfirmationId}}
          </h4>
          <h4>
            <v-icon v-if="statusCheck.Status">check_circle_outline</v-icon>
            <v-icon v-if="!statusCheck.Status">highlight_off</v-icon>
            {{$translate('PAR_CON_STATUS')}} {{orderStatus}}
          </h4>
        </v-card>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
  import Router from "vue-router";
  import appConfig from "../../config/app_config";
  import UserObject from "../objects/UserObject.js";
  import * as dssRequest from "../api/dssRequest";
  import { store } from "../store";
  import BaseComponent from "./base/BaseComponent.vue";
  import BaseObject from "../objects/BaseObject";

  export default {
    name: 'PartnerConfirmation',
    mounted() {
      this.readUrlAndProceed();
    },
    data() {
      return {
        statusCheck: {},
        orderStatus: '',
        leadText: '',
        loading: true,
        functionName: '',
        queryObject: {}
      };
    },
    methods: {
      readUrlAndProceed() {
        this.statusCheck = {
          Order: true,
          Confirmation: true,
          Status: true
        };
        this.queryObject.OrderId = this.$route.query.OrderID;
        this.queryObject.ConfirmationId = this.$route.query.confirmationID;
        const action = this.$route.query.action;
        this.functionName = '';
        if (action === 'accept') this.functionName = 'acceptOrder';
        else if (action === 'reject') this.functionName = 'rejectOrder';
        else return;
        const payload = this.queryObject;

        dssRequest.doRequest(
          response => {
            console.log("The call for " + this.functionName + " was successful", response);

            this.functionName === 'acceptOrder' ? this.orderStatus = this.$translate('PAR_CON_OR_ST_ACC') : this.orderStatus = this.$translate('PAR_CON_OR_ST_REJ');
            this.leadText = this.$translate('PAR_CON_LEAD_P1') + this.queryObject.OrderId + this.$translate('PAR_CON_LEAD_P2') + this.orderStatus;
            setTimeout(() => {
              this.loading = false;
            }, 250)
          },
          error => {

            console.log("The call for " + this.functionName + " was not successful", error);
            this.leadText = this.$translate('PAR_CON_LEAD_P3');
            this.orderStatus = this.$translate('PAR_CON_OR_ST_FAI');
            if (error.data.hasOwnProperty('ErrorMsg')) {
              if (error.data.ErrorMsg === 'E_OM_001') {
                this.statusCheck = {
                  Order: false,
                  Confirmation: true,
                  Status: false
                };
                // window.EventBus.fire(
                //   "triggerGenericErrorDialog",
                //   "E_OM_001");
              } else if (error.data.ErrorMsg === 'E_OM_002') {
                this.statusCheck = {
                  Order: true,
                  Confirmation: false,
                  Status: false
                };
                // window.EventBus.fire(
                //   "triggerGenericErrorDialog",
                //   "E_OM_002");
              } else if (error.data.ErrorMsg === 'E_OM_003') {

                this.statusCheck = {
                  Order: false,
                  Confirmation: false,
                  Status: false
                };
                // window.EventBus.fire(
                //   "triggerGenericErrorDialog",
                //   "E_OM_003");
                return;
              } else {
                this.statusCheck = {
                  Order: true,
                  Confirmation: true,
                  Status: false
                };
              }
            } else {
              this.statusCheck = {
                Order: true,
                Confirmation: true,
                Status: false
              };
            }
            setTimeout(() => {
              this.loading = false;
            }, 250)
          },
          this.functionName,
          store.getters.getCurrentAccountId + "_OM",
          payload,
          600000,
          false
        );
      }
    }
  };
</script>

<style scoped>
  .web_home_style {
    background-color: rgba(124, 158, 158, 0.9);
    width: auto;
    height: 100vh;
    /*padding: -24px !important;*/
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -4em;
  }
  .web_home_style_mobile {
    width: auto;
    height: 100vh;
    /*padding: -24px !important;*/
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -4em;
  }
</style>
